import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RolListComponent } from './list/rol-list.component';
import { RolViewComponent } from './view/rol-view.component';
import { RolEditComponent } from './edit/rol-edit.component';
import { RolNewComponent } from './new/rol-new.component';
import { RolComponent } from './rol.component';
import { NgModule } from '@angular/core';
import { RolRoutingModule, ROUTABLE_COMPONENTS } from './rol.routing';
import { MatTableModule, MatSelectModule, MatTooltipModule } from '@angular/material';
import { RolService } from './shared/rol.service';
import { MatButtonModule, MatInputModule, MatCheckboxModule, MatFormFieldModule, MatSlideToggleModule, MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { RolAccessListComponent } from './listAccess/rol-access-list.component';
import { UserRolListComponent } from './listUsers/rol-user-list.component';
import { RolParametroAutonomiaModule } from '../rolParametroAutonomia/rol-parametro-autonomia.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';
import { AccesoUsuarioListComponent } from '../Roles/listAccesoUsuario/acceso-usuario-list.component';
import { AccesoSubmoduloListComponent } from '../Roles/listAccesoSubmodulo/acceso-submodulo-list.component';
/**
 *
 *
 * @export
 * @class RolModule
 */
@NgModule({
    imports: [
        BrowserModule,
        MatTableModule,
        RolRoutingModule,
        MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
        FormsModule, ReactiveFormsModule,
        FabButtonGroupModule, MatSelectModule,
        SectionBarModule, MatSlideToggleModule,
        TitlebarModule, HeaderModule, LoaderModule, SnackbarModule,
        RolParametroAutonomiaModule,
        GridEmptyModule,
        MatTooltipModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [

        RolListComponent,
        RolViewComponent,
        RolEditComponent,
        RolNewComponent,
        RolComponent,
        RolAccessListComponent,
        UserRolListComponent,
        ROUTABLE_COMPONENTS,
        AccesoUsuarioListComponent,
        AccesoSubmoduloListComponent
    ],
    providers: [RolService],
    bootstrap: []
})
export class RolModule {
}
